/* Reserve space for the visible Consentmo bar without changing consent state. */
(() => {
  const property = '--qa-offer-consent-space';
  let root;
  const phone = window.matchMedia('(max-width: 767px)');
  let frame = 0;
  let host = null;
  let shadow = null;
  let banner = null;
  let shadowObserver = null;
  let shadowRetry = 0;
  let shadowAttempts = 0;
  let lastSpace = '';
  const resizeObserver = new ResizeObserver(schedule);

  function schedule() {
    if (!frame) frame = requestAnimationFrame(measure);
  }

  function measure() {
    frame = 0;
    const nextHost = document.querySelector('csm-cookie-consent');
    if (host !== nextHost) {
      host = nextHost;
      shadow = null;
      banner = null;
      shadowAttempts = 0;
      shadowObserver?.disconnect();
      resizeObserver.disconnect();
      clearTimeout(shadowRetry);
    }

    if (host?.shadowRoot && shadow !== host.shadowRoot) {
      shadow = host.shadowRoot;
      shadowObserver = new MutationObserver(schedule);
      shadowObserver.observe(shadow, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
      });
    } else if (host && !shadow && shadowAttempts++ < 50) {
      clearTimeout(shadowRetry);
      shadowRetry = setTimeout(schedule, 100);
    }

    const nextBanner = shadow?.querySelector('.csm-cmp-bar.cc-bottom') || null;
    if (banner !== nextBanner) {
      resizeObserver.disconnect();
      banner = nextBanner;
      if (banner) resizeObserver.observe(banner);
    }

    const offer = document.querySelector('form[data-testid="klaviyo-form-S8mmv7"]')
      ?.closest('[data-kl-scroll-locking-modal][role="dialog"]');
    let space = '';
    if (phone.matches && offer && banner) {
      const rect = banner.getBoundingClientRect();
      const style = getComputedStyle(banner);
      const viewport = window.innerHeight;
      if (rect.width > 0 && rect.height > 0 && rect.top > 0 && rect.top < viewport
        && rect.bottom > 0 && style.display !== 'none'
        && style.visibility !== 'hidden' && Number(style.opacity) > 0) {
        // Leave room for the close target if an unusually tall banner appears.
        space = `${Math.min(viewport - 88, viewport - rect.top + 12)}px`;
      }
    }

    if (space !== lastSpace) {
      if (space) root.style.setProperty(property, space);
      else root.style.removeProperty(property);
      lastSpace = space;
    }
  }

  function start() {
    root = document.documentElement;
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    phone.addEventListener('change', schedule);
    customElements.whenDefined('csm-cookie-consent').then(schedule);
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
